import React from 'react'
import {
  HookRouter as HookRouterTypes,
  useRedirect,
  useRoutes,
} from 'hookrouter'

import { AuthorizedView } from 'pages/AuthorizedView'
import { CompanyView } from 'pages/CompanyView'
import { EditCompanyForm } from 'components/EditCompanyForm'
import { EditTemplateForm } from 'components/EditTemplateForm'
import { EditUserForm } from 'pages/EditUserForm'
import { LOGIN_ROUTES } from 'pages/LoginRouter'
import { NewCompanyForm } from 'components/NewCompanyForm'
import { NewProjectForm } from 'components/NewProjectForm'
import { NewProjectTemplateDocumentForm } from 'components/NewProjectTemplateDocumentForm'
import { NewProjectFolderCreationForm } from 'components/NewProjectFolderCreationForm'
import { NotFound } from 'pages/NotFound'
import { ProjectTemplates } from 'pages/ProjectTemplates'
import { ProjectDirectoryDisplay } from 'components/ProjectDirectoryDisplay';
import { ProjectSubDirectoryDisplay } from 'components/ProjectSubDirectoryDisplay';
import { WelcomeView } from 'pages/WelcomeView'
import { ProjectUsersList } from 'components/ProjectUsersList'
import { ProjectPermissionsList } from 'components/ProjectPermissionsList'

export const APP_ROUTES = {
  company: '/company/:companyId',
  editCompany: '/company/:companyId/edit',
  editTemplate:
    '/company/:companyId/project/:projectId/templateDocument/:templateDocumentId/edit',
  editUser: '/user/edit',
  newCompany: '/company/new',
  newProject: '/company/:companyId/new_project',
  newTemplate: '/company/:companyId/project/:projectId/new_template_document',
  newTemplateDirectory: '/company/:companyId/project/:projectId/directory/:directoryId/new_template_document',
  newTemplateSubDirectory: '/company/:companyId/project/:projectId/directory/:directoryId/subDirectory/:subDirectoryId/new_template_document',
  newFolder: '/company/:companyId/project/:projectId/new_folder',
  newSubFolder: '/company/:companyId/project/:projectId/directory/:templateDocumentId/new_folder',
  newSubDirectory: '/company/:companyId/project/:projectId/directory/:templateDocumentId/subFolder/:subFolderId',
  directory: '/company/:companyId/project/:projectId/directory/:templateDocumentId',
  project: '/company/:companyId/project/:projectId',
  registration: '/registration',
  root: '/',
  signDocument: '/documents/:documentId/sign/:status',
  projectUsersList: '/company/:companyId/project/:projectId/projectUsersList/:projectUserType',
  projectPermissionList: '/company/:companyId/project/:projectId/projectPermissionList/:projectUserType',
}
export const AppRouter = () => {
  const routes = {
    [APP_ROUTES.editCompany]: ({ companyId }) => (
      <AuthorizedView companyId={Number(companyId)}>
        <EditCompanyForm companyId={Number(companyId)} />
      </AuthorizedView>
    ),
    [APP_ROUTES.newCompany]: () => (
      <AuthorizedView>
        <NewCompanyForm />
      </AuthorizedView>
    ),
    [APP_ROUTES.newProject]: ({ companyId }) => (
      <AuthorizedView companyId={Number(companyId)}>
        <NewProjectForm companyId={Number(companyId)} />
      </AuthorizedView>
    ),
    [APP_ROUTES.newTemplate]: ({ companyId, projectId }) => (
      <AuthorizedView
        companyId={Number(companyId)}
        projectId={Number(projectId)}>
        <NewProjectTemplateDocumentForm
          projectId={Number(projectId)}
          companyId={Number(companyId)}
        />
      </AuthorizedView>
    ),
    [APP_ROUTES.newTemplateDirectory]: ({ companyId, projectId, directoryId }) => (
      <AuthorizedView
        companyId={Number(companyId)}
        projectId={Number(projectId)}>
        <NewProjectTemplateDocumentForm
          projectId={Number(projectId)}
          companyId={Number(companyId)}
          directoryId={Number(directoryId)}
        />
      </AuthorizedView>
    ),
    [APP_ROUTES.newTemplateSubDirectory]: ({ companyId, projectId, directoryId, subDirectoryId }) => (
      <AuthorizedView
        companyId={Number(companyId)}
        projectId={Number(projectId)}>
        <NewProjectTemplateDocumentForm
          projectId={Number(projectId)}
          companyId={Number(companyId)}
          directoryId={Number(directoryId)}
          subDirectoryId={Number(subDirectoryId)}
        />
      </AuthorizedView>
    ),

    [APP_ROUTES.newFolder]: ({ companyId, projectId, templateDocumentId }) => (
      <AuthorizedView
        companyId={Number(companyId)}
        projectId={Number(projectId)}>
        <NewProjectFolderCreationForm
          projectId={Number(projectId)}
          companyId={Number(companyId)}
          templateDocumentId={Number(templateDocumentId)}
        />
      </AuthorizedView>
    ),
    [APP_ROUTES.newSubFolder]: ({ companyId, projectId, templateDocumentId }) => (
      <AuthorizedView
        companyId={Number(companyId)}
        projectId={Number(projectId)}
        templateDocumentId={Number(templateDocumentId)}>
        <NewProjectFolderCreationForm
          projectId={Number(projectId)}
          companyId={Number(companyId)}
          templateDocumentId={Number(templateDocumentId)}
        />
      </AuthorizedView>
    ),
    [APP_ROUTES.newSubDirectory]: ({ companyId, projectId, templateDocumentId, subFolderId}) => (
      <AuthorizedView
        companyId={Number(companyId)}
        projectId={Number(projectId)}
        templateDocumentId={Number(templateDocumentId)}
        templateSubDocumentId={Number(subFolderId)}
        >
        <ProjectSubDirectoryDisplay
          projectId={Number(projectId)}
          companyId={Number(companyId)}
          templateDocumentId={Number(templateDocumentId)}
          templateSubDocumentId={Number(subFolderId)}
        />
      </AuthorizedView>
    ),
    [APP_ROUTES.editTemplate]: ({
      companyId,
      projectId,
      templateDocumentId,
    }) => (
      <AuthorizedView
        companyId={Number(companyId)}
        projectId={Number(projectId)}
        isTemplate={true}
        >
        <EditTemplateForm
          companyId={Number(companyId)}
          projectId={Number(projectId)}
          templateDocumentId={Number(templateDocumentId)}
        />
      </AuthorizedView>
    ),
    [APP_ROUTES.project]: ({ companyId, projectId }) => (
      <AuthorizedView
        companyId={Number(companyId)}
        projectId={Number(projectId)}>
        <ProjectTemplates
          companyId={Number(companyId)}
          projectId={Number(projectId)}
        />
      </AuthorizedView>
    ),
    [APP_ROUTES.projectUsersList]: ({ companyId, projectId, projectUserType }) => (
      <AuthorizedView
        companyId={Number(companyId)}
        projectId={Number(projectId)}
        projectUserType={Number(projectUserType)}>
        <ProjectUsersList
          companyId={Number(companyId)}
          projectId={Number(projectId)}
          projectUserType={Number(projectUserType)}
        />
      </AuthorizedView>
    ),
    [APP_ROUTES.projectPermissionList]: ({ companyId, projectId, projectUserType }) => (
      <AuthorizedView
        companyId={Number(companyId)}
        projectId={Number(projectId)}
        projectPermissionType={Number(projectUserType)}>
        <ProjectPermissionsList
          companyId={Number(companyId)}
          projectId={Number(projectId)}
          projectUserType={Number(projectUserType)}
        />
      </AuthorizedView>
    ),
    [APP_ROUTES.directory]: ({ companyId, projectId, templateDocumentId }) => (
      <AuthorizedView
        companyId={Number(companyId)}
        projectId={Number(projectId)}
        templateDocumentId={Number(templateDocumentId)}>
        <ProjectDirectoryDisplay
          companyId={Number(companyId)}
          projectId={Number(projectId)}
          templateDocumentId = {Number(templateDocumentId)}
        />
      </AuthorizedView>
    ),
    [APP_ROUTES.editUser]: () => (
      <AuthorizedView>
        <EditUserForm />
      </AuthorizedView>
    ),
    [APP_ROUTES.company]: ({ companyId }) => (
      <AuthorizedView companyId={Number(companyId)}>
        <CompanyView companyId={Number(companyId)} />
      </AuthorizedView>
    ),
    [APP_ROUTES.root]: () => (
      <AuthorizedView>
        <WelcomeView />
      </AuthorizedView>
    ),
  } as HookRouterTypes.RouteObject

  useRedirect(LOGIN_ROUTES.login, APP_ROUTES.root)
  useRedirect(LOGIN_ROUTES.passwordReset, APP_ROUTES.root)
  useRedirect(LOGIN_ROUTES.passwordResetTrigger, APP_ROUTES.root)

  return useRoutes(routes) || <NotFound />
}
